import { PlotlyTraceType } from '@/types';

export function breakBetweenWords(text: string | number): string {
  return text.toString().split(' ').join('<br>');
}
// combine traces in array. for example `txtwrapper([trace1, trace2])`
export const txtwrapper = (traces: PlotlyTraceType[]) => {
  for (const trace of traces) {
    trace.x = trace.x.map(text => {
      return breakBetweenWords(text);
    });
  }
  return traces;
};
